import * as ng from "@angular/core";
import { environment } from "src/env/environment";

@ng.Injectable()
export class ConsoleLogger {

  info(className: string, funcName: string, title: string, data: any): void {
    if (environment.name === 'local' || environment.name === 'stage') {
      if ( typeof(data) !== 'object') {
        console.log(`[Class:${className}, Func:${funcName}] ${title} : ${data}`);
      } else {
        console.log(`[Class:${className}, Func:${funcName}] ${title} : `, data);
      }
    }
  }

  /**
   * メッセージだけ表示(データ無し)
   */
  message(className: string, funcName: string, message: string): void {
    if (environment.name === 'local' || environment.name === 'stage') {
      console.log(`[Class:${className}, Func:${funcName}] ${message}`);
    }
  }
}